import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

import { ALLOWED_MODULES } from "../../constants/enums";
import path from "path";
import { REACT_APP_NAV_ROUTES } from "../../router/AppNavigation";

const CompanyWallet = Loadable(
  lazy(() =>
    import("./CompanyWallet").then(({ CompanyWallet }) => ({
      default: CompanyWallet,
    })),
  ),
);

export const CompanyWalletRoutes = [
  {
    path: REACT_APP_NAV_ROUTES.OrganizationSettings.companyWallet,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.COMPANY_WALLET]}>
        <CompanyWallet />
      </AuthorizedRoute>
    ),
  },
];
